import React from 'react'
import {Flex, Tabs} from '/app/src/component';
import PostHistory from './PostHistory';
import Preview from './Preview';
import TabIcon from './TabIcon';


class FeedbackRightPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            active: 0
        }
    }

    _tabFactory(idx) {
        const {active} = this.state
        switch(idx) {
            case 0:
                return <TabIcon
                    onClick={() => this.setState({active: 0})}
                    active={active === 0}
                    svgSrc='/images/Preview_M.svg'
                    text={'Förhandsvisning'}/>
            case 1:
            default:
                return <TabIcon
                    onClick={() => this.setState({active: 1})}
                    active={active === 1}
                    svgSrc='/images/HelpdeskPerformance_M.svg'
                    text='Feedback'/>
        }
    }

    render() {
        const previewTab = this._tabFactory(0)
        const feedbackTab = this._tabFactory(1)
        const {faqId} = this.props
        const {active} = this.state
        return (
            <Flex w='100%' h='100%'>
                <Tabs
                    active={active}
                    header={[previewTab, feedbackTab]}
                    body={[<Preview faqId={faqId}/>, <PostHistory faqId={faqId}/>]} />
            </Flex>
        )
    }
}

export default FeedbackRightPanel



// WEBPACK FOOTER //
// ./src/layout/Dashboard/RightPanel/ClientChatMenu/HelpDesk/RightPanel/index.js